/**
 * Admin root layout route
 * Protected route that requires admin privileges
 */

import { createFileRoute, Outlet } from '@tanstack/react-router';
import { AdminLayout } from '../components/admin/AdminLayout';

export const Route = createFileRoute('/admin')({
  component: AdminRoot,
});

function AdminRoot() {
  return (
    <AdminLayout>
      <Outlet />
    </AdminLayout>
  );
}
